import { styled } from 'styled-components';

export default styled.div`
    .subHeading {
        color: ${(props) => props.theme.tertiaryFontColor};
        font-family: Poppins, serif;
        font-size: 18px;
        font-weight: 700;
        margin-top: 32px;
    }

    .list {
        display: flex;
        ustify-content: flex-start;
        align-items: center;
        padding: 5px 0;
    }

    .heading {
        color: ${(props) => props.theme.tertiaryFontColor};
        font-family: Poppins;
        font-size: 28px;
        font-weight: 700;
    }

    .text {
        color: #000;
        margin-left: 5px;
        font-family: Poppins, serif;
        font-size: 12.161px;
        font-weight: 400;
    }

    .parentList {
        padding: 20px 0;
        border-bottom: 1px solid #c4c4c4;
    }

    .field {
        margin-top: 32px;
    }

    .fieldSet {
        margin-bottom: 20px;

        label {
            color: rgba(26, 26, 26, 0.7);
            font-family: Poppins, serif;
            font-size: 12px;
            font-weight: 600;
        }
    }

    .legalText {
        color: ${(props) => props.theme.tertiaryFontColor};
        font-family: Poppins;
        font-size: 12px;
        font-weight: 400;

        a {
            color: ${(props) => props.theme.colorButtonPrimary};
            font-family: Poppins, serif;
            font-size: 12px;
            font-weight: 600;
        }

        .createBtn {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 20px;
            width: 100%;
        }
    }
`;
